<template>
    <v-dialog 
      v-if="!authData"
      v-model="dialog"
      :fullscreen="!isDesktopCards"
      hide-overlay
      width="500"
    >
      <template 
        v-slot:activator="{ on }"
      >
        <v-btn
          small
          v-on="on"
          @click.stop.prevent="handleShowSignin"
          :color="Color"
          style="margin-top:3px;margin-bottom: 20px;text-shadow: 1px 1px gray;"
          v-show="!forceNoAuth"
          :outlined="!isDesktopCards"
          :text="isDesktopCards"
        >
        {{ $t('common.sigin', locale) }}
        </v-btn>
      </template>
    <v-card :color="BGColor" v-if="recoverPassword">
      <v-btn
          text
          x-small
          absolute
          top
          right
          :color="Color"
          @click="dialog = false"
          style="margin-right: -15px !important;margin-top: 0px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <center><v-icon style="margin-top: 30px;font-size:90px !important;" :style="{ 'color': Color}">mdi-account-circle</v-icon></center>
        <!-- <center style="margin-top:10px;margin-bottom:20px;"><h3 style="font-weight:400;" :style="{ 'color': Color}">{{$t('customAuth.guestAccess').toUpperCase()}}</h3></center>         -->
        <v-layout wrap>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('users.email', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="recoveryEmail"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
        </v-layout>
        <v-card-text style="margin-top:10px;height: 300px;">
          <v-alert v-if="message" dense outlined color="red">
            {{message}}
          </v-alert>
          <v-layout wrap style="padding: 5px">
            <v-flex xs12>
            <v-btn :disabled="loading" :color="Color" outlined block @click.stop.prevent="handleSendMail">{{$t('common.sendMail', locale)}}</v-btn>
            </v-flex>
            <v-flex xs12 style="margin-top:20px;">
            <center>
              <v-btn :disabled="loading" color="white" @click.stop.prevent="recoverPassword = false" text>
                {{$t('common.cancel', locale)}}
              </v-btn>
            </center>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card :color="BGColor" v-else>
        <v-btn
          text
          x-small
          absolute
          top
          right
          :color="Color"
          @click="dialog = false"
          style="margin-right: -15px !important;margin-top: 0px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <center><v-icon style="margin-top: 30px;font-size:90px !important;" :style="{ 'color': Color}">mdi-account-circle</v-icon></center>
        <!-- <center style="margin-top:10px;margin-bottom:20px;"><h3 style="font-weight:400;" :style="{ 'color': Color}">{{$t('customAuth.guestAccess').toUpperCase()}}</h3></center>         -->
        <v-layout wrap>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('users.email', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="name"
            type="email"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('users.password', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="password"
            type="password"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
        </v-layout>
        <v-card-text style="margin-top:10px;height: 300px;">
          <v-alert v-if="message" dense outlined color="red">
            {{message}}
          </v-alert>
          <v-layout wrap style="padding: 5px">
            <v-flex xs12>
            <v-btn :disabled="loading" :color="Color" outlined block @click.stop.prevent="handleSigin">{{$t('common.sigin', locale)}}</v-btn>
            </v-flex>
            <v-flex xs12 style="margin-top:20px;">
            <center>
              <v-btn :disabled="loading" color="white" @click.stop.prevent="handleRecoverPassword" text>
                {{$t('common.recoverPassword', locale)}}
              </v-btn>
            </center>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-else-if="authType !== 'none' && authData"
      v-model="dialogLogout"
      fullscreen
      hide-overlay
    >
      <template v-slot:activator="{ onLogout }">        
        <v-btn
          text
          :color="Color"
          v-on="onLogout"
          @click.stop="dialogLogout = true"
          style="text-shadow: 1px 1px gray;"
        >
          
          {{authData.name}}
        </v-btn>
      </template>
      <v-card :color="BGColor">        
        <v-card-title :style="{ 'color': Color}">{{ $t('dashboard.logout', locale) }}</v-card-title>
        <v-card-text :style="{ 'color': Color}">{{ $t('customAuth.logoutMsg', locale) }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :color="Color"
            text 
            @click="dialogLogout = false"
          >
            {{$t('common.cancel')}}
          </v-btn>

          <v-btn
            :color="Color"
            text
            @click="handleLogout"
          >
            {{$t('dashboard.logout')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import tinycolor from 'tinycolor2'
  import axios from 'axios'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    props: {
      dialogAuth: {
        type: Boolean,
        require: false,
        default: null
      },
      isDesktopCards: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogLogout: false,
      name: '',
      password: '',
      message: null,
      recoverPassword: false,
      recoveryEmail: '',
    }),
    computed: {
      ...mapState('app',['locale', 'authData', 'btnBackgroundColor', 'btnTextColor', 'Color', 'BGColor', 'FontContent', 'FontSizeContent', 'ColorContent']),
      isDev () {
        return process.env.VUE_APP_ENV === 'development'
      },
      authType () {
        return this.$store.state.app.authType
      },
      dfileWorkspace () {
        return this.$store.state.app.dfileWorkspace
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      isLight () {
        return tinycolor(this.BGColor).isLight()
      },
      dfileResp () {
        return this.$route.query.dfileResp && this.$route.query.dfileResp.length > 0 ? this.$route.query.dfileResp : null
      },
      forceNoAuth () {
        return this.$route.query.noauth && this.$route.query.noauth === 'true' ? true : false
      }
    },
    watch: {
      dialogAuth (newValue) {
        if(newValue) this.dialog = true
      }
    },
    mounted () {
      if ((this.$session.get('dfilesResponse') || this.dfileResp) && !this.authData) this.handleCheckToken()
      if (this.isDev) {
        /*
        this.name = 'fridrik@icorapartners.com'
        this.password = '97QMSdyr'
        this.recoveryEmail = 'javier@descubregroup.com'
        */
        this.name = 'javier@descubregroup.com'
        this.password = '123123123'
        this.recoveryEmail = 'javier@descubregroup.com'
      }
      // this.handleCheckSigin()
    },
    methods: {
      handleCheckToken () {
        const dfileToken = this.$session.get('dfilesResponse') || this.dfileResp
        axios.get(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/info/?token=${dfileToken}`)
          .then(response => {
            this.$store.state.app.authData = {
              id: response.data.ID,
              name: response.data.Name
            }
          })
          .catch( (error) => {
            console.log(error)
            this.$store.state.app.authData = null
            this.$session.set('dfilesResponse', null)
          })
          .finally(() => {
            this.loading = false
          })
      },
      handleShowSignin() {
        if (this.dialog) {
          this.dialog = false
          setTimeout(() => {
            this.dialog = true
          }, 500)
        } else this.dialog = true
      },
      handleLogout () {
        this.$store.state.app.authData = null
        this.$session.set('dfilesResponse', null)
        this.dialogLogout = false
      },
      handleEnter (e) {
        if (e.keyCode === 13) this.handleSigin()
      },
      handleRecoverPassword () {
        this.recoverPassword = true
      },
      handleSendMail () {
        const body = {
          email: this.recoveryEmail,
          domain: utils.getDomain(),
          dfileWorkspace: this.dfileWorkspace,
        }
        axios.post(`${process.env.VUE_APP_API_URL_DFILES}/public/authenticate/recovery-mail`, body)
        .then(response => {
          console.log(response)
          this.loading = false
          this.recoverPassword = false
          this.dialog = false
        })
        .catch(error => {
          if (error && error.response && error.response.status === 401) this.message = this.$t('customAuth.noray.noBookin')
          if (error && error.response && error.response.status === 404) this.message = this.$t('customAuth.noray.error')
          else this.message = this.$t('customAuth.noray.error')
          this.loading = false
        })
      },
      handleSigin () {
        this.message = null
        this.loading = true
        const sha1 = require('js-sha1')
        const body = {
          name: this.name.toLowerCase(),
          password: sha1(this.password),
          workspace: this.dfileWorkspace,
        }
        axios.post(`${process.env.VUE_APP_API_URL_DFILES}/public/authenticate`, body)
        .then(response => {
          this.$store.state.app.authData = {
            id: response.data.user.ID,
            name: response.data.user.Name,
            workspace: this.dfileWorkspace
          }
          this.$session.set('dfilesResponse', response.data.token)
          this.loading = false
        })
        .catch(error => {
          console.log('jhm', error)
          if (error && error.response && error.response.status === 401) this.message = this.$t('customAuth.noray.noBookin')
          else this.message = this.$t('customAuth.noray.error')
          this.loading = false
        })
      }
    }
  }
</script>
